import { AfterViewInit, Directive, HostBinding, Input } from '@angular/core';
import { CmSettingsService } from '@ats/cm/core';
import { delay, take } from 'rxjs/operators';

const INTERNAL_HOSTS = ['certmetricslocal.com', 'certmetrics.com'];

@Directive({
    selector: '[href][cmInternalize]',
    standalone: false
})
export class CmInternalizeLinkDirective implements AfterViewInit {
	@Input()
	@HostBinding('href')
	href?: string;

	constructor(private settings: CmSettingsService) {}

	ngAfterViewInit(): void {
		if (INTERNAL_HOSTS.some(host => (this.href || '').includes(host))) {
			this.parseRelativePath();
		}
	}

	private parseRelativePath(): void {
		this.settings.culture$.pipe(take(1), delay(1)).subscribe(culture => {
			const [basePath, remainingPath] = this.href.split(`${this.settings.client}/`);
			const [linkCulture, ...remainder] = (remainingPath || '').split('/');
			if (culture.code === linkCulture) {
				return;
			}
			this.href = `${basePath}${this.settings.client}/${culture.code}/${(remainder || []).join('/')}`;
		});
	}
}
